/**
 * Jurisdiction-aware Address Data Resolver
 *
 * PreSetTaskDetailPage 등에서 주소 관련 reference data
 * (states, cities, postcodes)를 jurisdiction 별로 다르게 가져와야 할 때 사용.
 *
 * 각 jurisdiction 은 자기 데이터를 plug-in 으로 등록한다.
 *
 * 사용:
 *   // my/preset/data/index.ts
 *   import malaysianStates from '../components/shared/data/common/malaysian-states.json';
 *   import cities from '../components/shared/data/common/cities.json';
 *   import postcodes from '../components/shared/data/common/postcodes.json';
 *   registerAddressData('MY', { states: malaysianStates, cities, postcodes });
 *
 *   // 호출
 *   const data = getAddressData(getCurrentJurisdiction() || 'MY');
 *   data.states  // states[]
 */

import type { Jurisdiction } from '../../../jurisdictionResolver';

export interface AddressRefData {
  states: any[];
  cities: any[];
  postcodes: any[];
  /** 추가 필드 자유롭게. */
  [key: string]: any;
}

const dataMap: Partial<Record<Jurisdiction, AddressRefData>> = {};

export function registerAddressData(jurisdiction: Jurisdiction, data: AddressRefData): void {
  dataMap[jurisdiction] = data;
}

/** jurisdiction 에 등록된 주소 데이터 반환. 없으면 빈 데이터. */
export function getAddressData(jurisdiction: Jurisdiction | null | undefined): AddressRefData {
  if (!jurisdiction) return { states: [], cities: [], postcodes: [] };
  return dataMap[jurisdiction] || { states: [], cities: [], postcodes: [] };
}

export function _clearAddressData(): void {
  for (const k of Object.keys(dataMap) as Jurisdiction[]) delete dataMap[k];
}
